export const getRecommendedPackages = (option) => {
  return option && option.publishOptions && Array.isArray(option.publishOptions.recommendedServicePackages)
    && option.publishOptions.recommendedServicePackages
    || [];
};
